// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * LUNA Streams API
 * VisionLabs LUNA Streams API. The API version is 1.

Service is intended for creation and management streams. "Stream" is an user logical entity.

Default port: 5160.

OpenAPI specification is the only valid document providing up-to-date information about the service LUNA Streams.

The specification can be used:

- By documentation generation tools to visualize the API.
- By code generation tools.

All the documents and code generated using this specification can include inaccuracies and should be carefully checked.

OpenAPI specification can be received using the [/docs/spec](#operation/getSpec) resource. The "Accept" header should be set to "application/x-yaml".

 * Version: v.1.5.2
 */import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CountGroupsParams,
  CountGroupsV2Params,
  CountStreams200,
  CountStreamsParams,
  CountStreamsV2200,
  CountStreamsV2Params,
  CreateGroup,
  CreateGroupResponse,
  CreateStream201,
  CreateStreamV2201,
  DeleteGroupParams,
  DeleteGroupV2Params,
  DeleteStreamsLogsParams,
  DeleteStreamsLogsV2Params,
  DeleteStreamsParams,
  DeleteStreamsV2Params,
  Error,
  FeedbackResponse,
  ForbiddenResourceErrorResponse,
  GetConfig200One,
  GetConfigV2200One,
  GetGroupParams,
  GetGroupV2Params,
  GetGroups200,
  GetGroupsParams,
  GetGroupsV2200,
  GetGroupsV2Params,
  GetStreamParams,
  GetStreamV2Params,
  GetStreams200,
  GetStreamsLogsParams,
  GetStreamsLogsV2Params,
  GetStreamsParams,
  GetStreamsQueueParams,
  GetStreamsQueueV2Params,
  GetStreamsV2200,
  GetStreamsV2Params,
  GroupResponse,
  GroupsCount,
  HealthErrors,
  HealthOk,
  HealthcheckParams,
  InternalServerErrorResponse,
  LicenseProblemResponse,
  Linker,
  LinkerParams,
  LinkerV2Params,
  PatchGroupParams,
  PatchGroupV2Params,
  PatchStreamParams,
  PatchStreamV2Params,
  Plugins,
  PostStreamsProcessingFeedbackRequest,
  PostStreamsProcessingQueueRequest,
  PreviewFrameProxyParams,
  PreviewLiveProxyParams,
  PutStream200,
  PutStreamV2200,
  QueueStreamsResponseInProgress,
  QueueStreamsResponseInProgressV2,
  QueueStreamsResponsePendingV1,
  QueueStreamsResponsePendingV2,
  RemoveStreamParams,
  RemoveStreamV2Params,
  StreamResponse,
  StreamResponseV2,
  StreamToBeCreated,
  StreamToBeCreatedV2,
  StreamToBePatched,
  StreamsLogs,
  StreamsLogsDeletedCount,
  StreamsToBeDeleted,
  UpdateGroup,
  Uuid,
  Version
} from './model';

import { streamsAxiosClient } from '../axios/streams-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get service version.
 * @summary get version
 */
export const getVersion = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<Version>(
      {url: `/version`, method: 'GET', signal
    },
      options);
    }




export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = InternalServerErrorResponse


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create stream.
 * @summary create stream
 */
export const createStream = (
    streamToBeCreated: StreamToBeCreated,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CreateStream201>(
      {url: `/1/streams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreated, signal
    },
      options);
    }




export const getCreateStreamMutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated}, TContext> => {

const mutationKey = ['createStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStream>>, {data: StreamToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createStream(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStreamMutationResult = NonNullable<Awaited<ReturnType<typeof createStream>>>
    export type CreateStreamMutationBody = StreamToBeCreated
    export type CreateStreamMutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary create stream
 */
export const useCreateStream = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStream>>,
        TError,
        {data: StreamToBeCreated},
        TContext
      > => {
      return useMutation(getCreateStreamMutationOptions(options), queryClient);
    }

/**
 * Get streams according to filters. The results are sorted by stream creation order, the oldest streams shown first.
 * @summary get streams
 */
export const getStreams = (
    params?: GetStreamsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetStreams200>(
      {url: `/1/streams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsQueryKey = (params?: GetStreamsParams,) => {
    return [
    `/1/streams`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsQueryOptions = <TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | InternalServerErrorResponse>(params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreams>>> = ({ signal }) => getStreams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreams>>>
export type GetStreamsQueryError = Error | InternalServerErrorResponse


export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams
 */

export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams matching specified filters (OR).
 * @summary delete streams
 */
export const deleteStreams = (
    streamsToBeDeleted: StreamsToBeDeleted,
    params?: DeleteStreamsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/streams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: streamsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteStreamsMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext> => {

const mutationKey = ['deleteStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreams>>, {data: StreamsToBeDeleted;params?: DeleteStreamsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteStreams(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreams>>>
    export type DeleteStreamsMutationBody = StreamsToBeDeleted
    export type DeleteStreamsMutationError = Error | InternalServerErrorResponse

    /**
 * @summary delete streams
 */
export const useDeleteStreams = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreams>>,
        TError,
        {data: StreamsToBeDeleted;params?: DeleteStreamsParams},
        TContext
      > => {
      return useMutation(getDeleteStreamsMutationOptions(options), queryClient);
    }

/**
 * Count streams according to the filters.
 * @summary count streams
 */
export const countStreams = (
    params?: CountStreamsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CountStreams200>(
      {url: `/1/streams/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountStreamsQueryKey = (params?: CountStreamsParams,) => {
    return [
    `/1/streams/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountStreamsQueryOptions = <TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | InternalServerErrorResponse>(params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountStreamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countStreams>>> = ({ signal }) => countStreams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof countStreams>>>
export type CountStreamsQueryError = Error | InternalServerErrorResponse


export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  CountStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreams>>,
          TError,
          Awaited<ReturnType<typeof countStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreams>>,
          TError,
          Awaited<ReturnType<typeof countStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary count streams
 */

export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountStreamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get the stream by ID.
 * @summary get stream
 */
export const getStream = (
    streamId: Uuid,
    params?: GetStreamParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamResponse>(
      {url: `/1/streams/${streamId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamQueryKey = (streamId: Uuid,
    params?: GetStreamParams,) => {
    return [
    `/1/streams/${streamId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamQueryOptions = <TData = Awaited<ReturnType<typeof getStream>>, TError = Error | InternalServerErrorResponse>(streamId: Uuid,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStream>>> = ({ signal }) => getStream(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamQueryResult = NonNullable<Awaited<ReturnType<typeof getStream>>>
export type GetStreamQueryError = Error | InternalServerErrorResponse


export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params: undefined |  GetStreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream
 */

export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update stream fields: *description*, *status*.
 * @summary update stream
 */
export const patchStream = (
    streamId: Uuid,
    streamToBePatched: StreamToBePatched,
    params?: PatchStreamParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/streams/${streamId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: streamToBePatched,
        params, signal
    },
      options);
    }




export const getPatchStreamMutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamParams}, TContext> => {

const mutationKey = ['patchStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStream>>, {streamId: Uuid;data: StreamToBePatched;params?: PatchStreamParams}> = (props) => {
          const {streamId,data,params} = props ?? {};

          return  patchStream(streamId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchStreamMutationResult = NonNullable<Awaited<ReturnType<typeof patchStream>>>
    export type PatchStreamMutationBody = StreamToBePatched
    export type PatchStreamMutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary update stream
 */
export const usePatchStream = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStream>>,
        TError,
        {streamId: Uuid;data: StreamToBePatched;params?: PatchStreamParams},
        TContext
      > => {
      return useMutation(getPatchStreamMutationOptions(options), queryClient);
    }

/**
 * Update existing stream. You should specify all the fields required for the stream in the request.
 * @summary put stream
 */
export const putStream = (
    streamId: Uuid,
    streamToBeCreated: StreamToBeCreated,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<PutStream200>(
      {url: `/1/streams/${streamId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreated, signal
    },
      options);
    }




export const getPutStreamMutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: Uuid;data: StreamToBeCreated}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: Uuid;data: StreamToBeCreated}, TContext> => {

const mutationKey = ['putStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStream>>, {streamId: Uuid;data: StreamToBeCreated}> = (props) => {
          const {streamId,data} = props ?? {};

          return  putStream(streamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutStreamMutationResult = NonNullable<Awaited<ReturnType<typeof putStream>>>
    export type PutStreamMutationBody = StreamToBeCreated
    export type PutStreamMutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary put stream
 */
export const usePutStream = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: Uuid;data: StreamToBeCreated}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStream>>,
        TError,
        {streamId: Uuid;data: StreamToBeCreated},
        TContext
      > => {
      return useMutation(getPutStreamMutationOptions(options), queryClient);
    }

/**
 * Remove the stream by ID.
 * @summary remove stream
 */
export const removeStream = (
    streamId: Uuid,
    params?: RemoveStreamParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/streams/${streamId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getRemoveStreamMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: Uuid;params?: RemoveStreamParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: Uuid;params?: RemoveStreamParams}, TContext> => {

const mutationKey = ['removeStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeStream>>, {streamId: Uuid;params?: RemoveStreamParams}> = (props) => {
          const {streamId,params} = props ?? {};

          return  removeStream(streamId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveStreamMutationResult = NonNullable<Awaited<ReturnType<typeof removeStream>>>

    export type RemoveStreamMutationError = Error | InternalServerErrorResponse

    /**
 * @summary remove stream
 */
export const useRemoveStream = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: Uuid;params?: RemoveStreamParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeStream>>,
        TError,
        {streamId: Uuid;params?: RemoveStreamParams},
        TContext
      > => {
      return useMutation(getRemoveStreamMutationOptions(options), queryClient);
    }

/**
 * See the streams in the queue.
 * @summary check the streams processing queue
 */
export const getStreamsQueue = (
    params: GetStreamsQueueParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<QueueStreamsResponsePendingV1>(
      {url: `/1/streams/processing/queue`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsQueueQueryKey = (params?: GetStreamsQueueParams,) => {
    return [
    `/1/streams/processing/queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsQueueQueryOptions = <TData = Awaited<ReturnType<typeof getStreamsQueue>>, TError = Error | InternalServerErrorResponse>(params: GetStreamsQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsQueueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsQueue>>> = ({ signal }) => getStreamsQueue(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsQueue>>>
export type GetStreamsQueueQueryError = Error | InternalServerErrorResponse


export function useGetStreamsQueue<TData = Awaited<ReturnType<typeof getStreamsQueue>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsQueue>>,
          TError,
          Awaited<ReturnType<typeof getStreamsQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsQueue<TData = Awaited<ReturnType<typeof getStreamsQueue>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsQueue>>,
          TError,
          Awaited<ReturnType<typeof getStreamsQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsQueue<TData = Awaited<ReturnType<typeof getStreamsQueue>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary check the streams processing queue
 */

export function useGetStreamsQueue<TData = Awaited<ReturnType<typeof getStreamsQueue>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueue>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 *
 * Receive streams from the queue. The streams are received according to the specified filters.
 *
 * The following actions are performed upon the request:
 *
 * - The streams are marked as "in progress".
 * - The streams are deleted from the Streams Processing Queue.
 *
 * The information about the streams is returned in the response.
 * @summary get some streams from the queue
 */
export const getStreamsFromQueue = (
    postStreamsProcessingQueueRequest?: PostStreamsProcessingQueueRequest,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<QueueStreamsResponseInProgress>(
      {url: `/1/streams/processing/queue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postStreamsProcessingQueueRequest, signal
    },
      options);
    }




export const getGetStreamsFromQueueMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueue>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueue>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext> => {

const mutationKey = ['getStreamsFromQueue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsFromQueue>>, {data?: PostStreamsProcessingQueueRequest}> = (props) => {
          const {data} = props ?? {};

          return  getStreamsFromQueue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsFromQueueMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsFromQueue>>>
    export type GetStreamsFromQueueMutationBody = PostStreamsProcessingQueueRequest | undefined
    export type GetStreamsFromQueueMutationError = Error | InternalServerErrorResponse

    /**
 * @summary get some streams from the queue
 */
export const useGetStreamsFromQueue = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueue>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsFromQueue>>,
        TError,
        {data?: PostStreamsProcessingQueueRequest},
        TContext
      > => {
      return useMutation(getGetStreamsFromQueueMutationOptions(options), queryClient);
    }

/**
 *
 * Post information about streams processing.
 * @summary post feedback on streams
 */
export const postStreamsFeedback = (
    postStreamsProcessingFeedbackRequest?: PostStreamsProcessingFeedbackRequest,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<FeedbackResponse>(
      {url: `/1/streams/processing/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postStreamsProcessingFeedbackRequest, signal
    },
      options);
    }




export const getPostStreamsFeedbackMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedback>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedback>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext> => {

const mutationKey = ['postStreamsFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStreamsFeedback>>, {data?: PostStreamsProcessingFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  postStreamsFeedback(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostStreamsFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof postStreamsFeedback>>>
    export type PostStreamsFeedbackMutationBody = PostStreamsProcessingFeedbackRequest | undefined
    export type PostStreamsFeedbackMutationError = Error | InternalServerErrorResponse

    /**
 * @summary post feedback on streams
 */
export const usePostStreamsFeedback = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedback>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStreamsFeedback>>,
        TError,
        {data?: PostStreamsProcessingFeedbackRequest},
        TContext
      > => {
      return useMutation(getPostStreamsFeedbackMutationOptions(options), queryClient);
    }

/**
 *
 * Get stream last frame preview.
 *
 * To add preview for stream, use ["post feedback on streams"](#operation/postStreamsFeedback) request to create last frame preview.
 * @summary get last frame preview
 */
export const previewFrameProxy = (
    streamId: string,
    params?: PreviewFrameProxyParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/streams/${streamId}/preview/handler/frame`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPreviewFrameProxyQueryKey = (streamId: string,
    params?: PreviewFrameProxyParams,) => {
    return [
    `/1/streams/${streamId}/preview/handler/frame`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewFrameProxyQueryOptions = <TData = Awaited<ReturnType<typeof previewFrameProxy>>, TError = Error>(streamId: string,
    params?: PreviewFrameProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewFrameProxyQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewFrameProxy>>> = ({ signal }) => previewFrameProxy(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewFrameProxyQueryResult = NonNullable<Awaited<ReturnType<typeof previewFrameProxy>>>
export type PreviewFrameProxyQueryError = Error


export function usePreviewFrameProxy<TData = Awaited<ReturnType<typeof previewFrameProxy>>, TError = Error>(
 streamId: string,
    params: undefined |  PreviewFrameProxyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFrameProxy>>,
          TError,
          Awaited<ReturnType<typeof previewFrameProxy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFrameProxy<TData = Awaited<ReturnType<typeof previewFrameProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewFrameProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFrameProxy>>,
          TError,
          Awaited<ReturnType<typeof previewFrameProxy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFrameProxy<TData = Awaited<ReturnType<typeof previewFrameProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewFrameProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get last frame preview
 */

export function usePreviewFrameProxy<TData = Awaited<ReturnType<typeof previewFrameProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewFrameProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewFrameProxyQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 *
 * Get stream live preview.
 *
 * To add preview for stream, use ["post feedback on streams"](#operation/postStreamsFeedback) request to create live preview.
 * @summary get live preview
 */
export const previewLiveProxy = (
    streamId: string,
    params?: PreviewLiveProxyParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/streams/${streamId}/preview/handler/live`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPreviewLiveProxyQueryKey = (streamId: string,
    params?: PreviewLiveProxyParams,) => {
    return [
    `/1/streams/${streamId}/preview/handler/live`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewLiveProxyQueryOptions = <TData = Awaited<ReturnType<typeof previewLiveProxy>>, TError = Error>(streamId: string,
    params?: PreviewLiveProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewLiveProxyQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewLiveProxy>>> = ({ signal }) => previewLiveProxy(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewLiveProxyQueryResult = NonNullable<Awaited<ReturnType<typeof previewLiveProxy>>>
export type PreviewLiveProxyQueryError = Error


export function usePreviewLiveProxy<TData = Awaited<ReturnType<typeof previewLiveProxy>>, TError = Error>(
 streamId: string,
    params: undefined |  PreviewLiveProxyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLiveProxy>>,
          TError,
          Awaited<ReturnType<typeof previewLiveProxy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLiveProxy<TData = Awaited<ReturnType<typeof previewLiveProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewLiveProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLiveProxy>>,
          TError,
          Awaited<ReturnType<typeof previewLiveProxy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLiveProxy<TData = Awaited<ReturnType<typeof previewLiveProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewLiveProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get live preview
 */

export function usePreviewLiveProxy<TData = Awaited<ReturnType<typeof previewLiveProxy>>, TError = Error>(
 streamId: string,
    params?: PreviewLiveProxyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxy>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewLiveProxyQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get streams logs according to filters. The results are sorted by log creation order, the new streams logs shown first.
 * @summary get streams logs
 */
export const getStreamsLogs = (
    params?: GetStreamsLogsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamsLogs>(
      {url: `/1/streams/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsLogsQueryKey = (params?: GetStreamsLogsParams,) => {
    return [
    `/1/streams/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsLogsQueryOptions = <TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | InternalServerErrorResponse>(params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsLogs>>> = ({ signal }) => getStreamsLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsLogs>>>
export type GetStreamsLogsQueryError = Error | InternalServerErrorResponse


export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetStreamsLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams logs
 */

export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams logs older than specified date excluding last log entry.
 *
 * Also you can run streams logs auto deletion by using `LUNA_STREAMS_LOGS_CLEAR_INTERVAL` setting.
 * For more information see development documentation.
 * @summary delete stream logs
 */
export const deleteStreamsLogs = (
    params?: DeleteStreamsLogsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamsLogsDeletedCount>(
      {url: `/1/streams/logs`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteStreamsLogsMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext> => {

const mutationKey = ['deleteStreamsLogs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreamsLogs>>, {params?: DeleteStreamsLogsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteStreamsLogs(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsLogsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreamsLogs>>>

    export type DeleteStreamsLogsMutationError = Error | InternalServerErrorResponse

    /**
 * @summary delete stream logs
 */
export const useDeleteStreamsLogs = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreamsLogs>>,
        TError,
        {params?: DeleteStreamsLogsParams},
        TContext
      > => {
      return useMutation(getDeleteStreamsLogsMutationOptions(options), queryClient);
    }

/**
 * Create group.
 * @summary create group
 */
export const createGroup = (
    createGroup: CreateGroup,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CreateGroupResponse>(
      {url: `/1/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroup, signal
    },
      options);
    }




export const getCreateGroupMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {data: CreateGroup}> = (props) => {
          const {data} = props ?? {};

          return  createGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = CreateGroup
    export type CreateGroupMutationError = Error | InternalServerErrorResponse

    /**
 * @summary create group
 */
export const useCreateGroup = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {data: CreateGroup},
        TContext
      > => {
      return useMutation(getCreateGroupMutationOptions(options), queryClient);
    }

/**
 * Get groups according to filters. The results are sorted by group creation order, the oldest group shown first.
 * @summary get groups
 */
export const getGroups = (
    params?: GetGroupsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetGroups200>(
      {url: `/1/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupsInfiniteQueryKey = (params?: GetGroupsParams,) => {
    return [
    'infinite', `/1/groups`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetGroupsQueryKey = (params?: GetGroupsParams,) => {
    return [
    `/1/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | InternalServerErrorResponse>(params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroups>>, QueryKey, GetGroupsParams['page']> = ({ signal, pageParam }) => getGroups({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getGroups>>>
export type GetGroupsInfiniteQueryError = Error | InternalServerErrorResponse


export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetGroupsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | InternalServerErrorResponse>(params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroups>>> = ({ signal }) => getGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getGroups>>>
export type GetGroupsQueryError = Error | InternalServerErrorResponse


export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Count of groups according to the filters.
 * @summary get group count
 */
export const countGroups = (
    params?: CountGroupsParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GroupsCount>(
      {url: `/1/groups/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountGroupsQueryKey = (params?: CountGroupsParams,) => {
    return [
    `/1/groups/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountGroupsQueryOptions = <TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | InternalServerErrorResponse>(params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countGroups>>> = ({ signal }) => countGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof countGroups>>>
export type CountGroupsQueryError = Error | InternalServerErrorResponse


export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  CountGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroups>>,
          TError,
          Awaited<ReturnType<typeof countGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroups>>,
          TError,
          Awaited<ReturnType<typeof countGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group count
 */

export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get the group by name.
 * @summary get group
 */
export const getGroup = (
    groupId: Uuid,
    params?: GetGroupParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GroupResponse>(
      {url: `/1/groups/${groupId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupQueryKey = (groupId: Uuid,
    params?: GetGroupParams,) => {
    return [
    `/1/groups/${groupId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupQueryOptions = <TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | InternalServerErrorResponse>(groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupQueryKey(groupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroup>>> = ({ signal }) => getGroup(groupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getGroup>>>
export type GetGroupQueryError = Error | InternalServerErrorResponse


export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params: undefined |  GetGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group
 */

export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupQueryOptions(groupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update group fields: *description*
 * @summary update group
 */
export const patchGroup = (
    groupId: Uuid,
    updateGroup: UpdateGroup,
    params?: PatchGroupParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroup,
        params, signal
    },
      options);
    }




export const getPatchGroupMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext> => {

const mutationKey = ['patchGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGroup>>, {groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}> = (props) => {
          const {groupId,data,params} = props ?? {};

          return  patchGroup(groupId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchGroupMutationResult = NonNullable<Awaited<ReturnType<typeof patchGroup>>>
    export type PatchGroupMutationBody = UpdateGroup
    export type PatchGroupMutationError = Error | InternalServerErrorResponse

    /**
 * @summary update group
 */
export const usePatchGroup = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGroup>>,
        TError,
        {groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams},
        TContext
      > => {
      return useMutation(getPatchGroupMutationOptions(options), queryClient);
    }

/**
 * Remove the group by name.
 * @summary remove group
 */
export const deleteGroup = (
    groupId: Uuid,
    params?: DeleteGroupParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/groups/${groupId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteGroupMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext> => {

const mutationKey = ['deleteGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroup>>, {groupId: Uuid;params?: DeleteGroupParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  deleteGroup(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>

    export type DeleteGroupMutationError = Error | InternalServerErrorResponse

    /**
 * @summary remove group
 */
export const useDeleteGroup = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroup>>,
        TError,
        {groupId: Uuid;params?: DeleteGroupParams},
        TContext
      > => {
      return useMutation(getDeleteGroupMutationOptions(options), queryClient);
    }

/**
 * Attach (or detach) streams to a group.
 * @summary attach (or detach) streams to a group
 */
export const linker = (
    linker?: Linker,
    params?: LinkerParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/1/linker`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: linker,
        params, signal
    },
      options);
    }




export const getLinkerMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker;params?: LinkerParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker;params?: LinkerParams}, TContext> => {

const mutationKey = ['linker'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linker>>, {data?: Linker;params?: LinkerParams}> = (props) => {
          const {data,params} = props ?? {};

          return  linker(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkerMutationResult = NonNullable<Awaited<ReturnType<typeof linker>>>
    export type LinkerMutationBody = Linker | undefined
    export type LinkerMutationError = Error | InternalServerErrorResponse

    /**
 * @summary attach (or detach) streams to a group
 */
export const useLinker = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker;params?: LinkerParams}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linker>>,
        TError,
        {data?: Linker;params?: LinkerParams},
        TContext
      > => {
      return useMutation(getLinkerMutationOptions(options), queryClient);
    }

/**
 * Get service OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept-Type* is `text/html`
 * @summary get openapi documentation
 */
export const getSpec = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<string>(
      {url: `/1/docs/spec`, method: 'GET', signal
    },
      options);
    }




export const getGetSpecQueryKey = () => {
    return [
    `/1/docs/spec`
    ] as const;
    }


export const getGetSpecQueryOptions = <TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpec>>> = ({ signal }) => getSpec(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getSpec>>>
export type GetSpecQueryError = Error | InternalServerErrorResponse


export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get openapi documentation
 */

export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpecQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get sphinx documentation - *Development Manual*. After the request you will be redirected to the page `/docs/dev/index.html`
 * @summary get development manual
 */
export const getDevManual = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<string>(
      {url: `/1/docs/dev`, method: 'GET', signal
    },
      options);
    }




export const getGetDevManualQueryKey = () => {
    return [
    `/1/docs/dev`
    ] as const;
    }


export const getGetDevManualQueryOptions = <TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevManualQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevManual>>> = ({ signal }) => getDevManual(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevManualQueryResult = NonNullable<Awaited<ReturnType<typeof getDevManual>>>
export type GetDevManualQueryError = InternalServerErrorResponse


export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get development manual
 */

export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevManualQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get service configuration. Passwords and tokens will be hidden in the response.
 * @summary get service configuration
 */
export const getConfig = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetConfig200One | string>(
      {url: `/1/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigQueryKey = () => {
    return [
    `/1/config`
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = Error | InternalServerErrorResponse


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service configuration
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get list of service plugins
 * @summary get list of plugins
 */
export const getPlugins = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<Plugins>(
      {url: `/1/plugins`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsQueryKey = () => {
    return [
    `/1/plugins`
    ] as const;
    }


export const getGetPluginsQueryOptions = <TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugins>>> = ({ signal }) => getPlugins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugins>>>
export type GetPluginsQueryError = InternalServerErrorResponse


export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of plugins
 */

export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPluginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create stream .
 * @summary create stream
 */
export const createStreamV2 = (
    streamToBeCreatedV2: StreamToBeCreatedV2,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CreateStreamV2201>(
      {url: `/2/streams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreatedV2, signal
    },
      options);
    }




export const getCreateStreamV2MutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStreamV2>>, TError,{data: StreamToBeCreatedV2}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createStreamV2>>, TError,{data: StreamToBeCreatedV2}, TContext> => {

const mutationKey = ['createStreamV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStreamV2>>, {data: StreamToBeCreatedV2}> = (props) => {
          const {data} = props ?? {};

          return  createStreamV2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStreamV2MutationResult = NonNullable<Awaited<ReturnType<typeof createStreamV2>>>
    export type CreateStreamV2MutationBody = StreamToBeCreatedV2
    export type CreateStreamV2MutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary create stream
 */
export const useCreateStreamV2 = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStreamV2>>, TError,{data: StreamToBeCreatedV2}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStreamV2>>,
        TError,
        {data: StreamToBeCreatedV2},
        TContext
      > => {
      return useMutation(getCreateStreamV2MutationOptions(options), queryClient);
    }

/**
 * Get streams according to filters. The results are sorted by stream creation order, the oldest streams shown first.
 * @summary get streams
 */
export const getStreamsV2 = (
    params?: GetStreamsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetStreamsV2200>(
      {url: `/2/streams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsV2QueryKey = (params?: GetStreamsV2Params,) => {
    return [
    `/2/streams`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsV2QueryOptions = <TData = Awaited<ReturnType<typeof getStreamsV2>>, TError = Error | InternalServerErrorResponse>(params?: GetStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsV2>>> = ({ signal }) => getStreamsV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsV2>>>
export type GetStreamsV2QueryError = Error | InternalServerErrorResponse


export function useGetStreamsV2<TData = Awaited<ReturnType<typeof getStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetStreamsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsV2<TData = Awaited<ReturnType<typeof getStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsV2<TData = Awaited<ReturnType<typeof getStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams
 */

export function useGetStreamsV2<TData = Awaited<ReturnType<typeof getStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams matching specified filters (OR).
 * @summary delete streams
 */
export const deleteStreamsV2 = (
    streamsToBeDeleted: StreamsToBeDeleted,
    params?: DeleteStreamsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/streams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: streamsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteStreamsV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsV2>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsV2>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsV2Params}, TContext> => {

const mutationKey = ['deleteStreamsV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreamsV2>>, {data: StreamsToBeDeleted;params?: DeleteStreamsV2Params}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteStreamsV2(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreamsV2>>>
    export type DeleteStreamsV2MutationBody = StreamsToBeDeleted
    export type DeleteStreamsV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary delete streams
 */
export const useDeleteStreamsV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsV2>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreamsV2>>,
        TError,
        {data: StreamsToBeDeleted;params?: DeleteStreamsV2Params},
        TContext
      > => {
      return useMutation(getDeleteStreamsV2MutationOptions(options), queryClient);
    }

/**
 * Count streams according to the filters.
 * @summary count streams
 */
export const countStreamsV2 = (
    params?: CountStreamsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CountStreamsV2200>(
      {url: `/2/streams/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountStreamsV2QueryKey = (params?: CountStreamsV2Params,) => {
    return [
    `/2/streams/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountStreamsV2QueryOptions = <TData = Awaited<ReturnType<typeof countStreamsV2>>, TError = Error | InternalServerErrorResponse>(params?: CountStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountStreamsV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countStreamsV2>>> = ({ signal }) => countStreamsV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountStreamsV2QueryResult = NonNullable<Awaited<ReturnType<typeof countStreamsV2>>>
export type CountStreamsV2QueryError = Error | InternalServerErrorResponse


export function useCountStreamsV2<TData = Awaited<ReturnType<typeof countStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  CountStreamsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreamsV2>>,
          TError,
          Awaited<ReturnType<typeof countStreamsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreamsV2<TData = Awaited<ReturnType<typeof countStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreamsV2>>,
          TError,
          Awaited<ReturnType<typeof countStreamsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreamsV2<TData = Awaited<ReturnType<typeof countStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary count streams
 */

export function useCountStreamsV2<TData = Awaited<ReturnType<typeof countStreamsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountStreamsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreamsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountStreamsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update existing stream. You should specify all the fields required for the stream in the request.
 * @summary put stream
 */
export const putStreamV2 = (
    streamId: Uuid,
    streamToBeCreatedV2: StreamToBeCreatedV2,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<PutStreamV2200>(
      {url: `/2/streams/${streamId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreatedV2, signal
    },
      options);
    }




export const getPutStreamV2MutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStreamV2>>, TError,{streamId: Uuid;data: StreamToBeCreatedV2}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putStreamV2>>, TError,{streamId: Uuid;data: StreamToBeCreatedV2}, TContext> => {

const mutationKey = ['putStreamV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStreamV2>>, {streamId: Uuid;data: StreamToBeCreatedV2}> = (props) => {
          const {streamId,data} = props ?? {};

          return  putStreamV2(streamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutStreamV2MutationResult = NonNullable<Awaited<ReturnType<typeof putStreamV2>>>
    export type PutStreamV2MutationBody = StreamToBeCreatedV2
    export type PutStreamV2MutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary put stream
 */
export const usePutStreamV2 = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStreamV2>>, TError,{streamId: Uuid;data: StreamToBeCreatedV2}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStreamV2>>,
        TError,
        {streamId: Uuid;data: StreamToBeCreatedV2},
        TContext
      > => {
      return useMutation(getPutStreamV2MutationOptions(options), queryClient);
    }

/**
 * Get the stream by ID.
 * @summary get stream
 */
export const getStreamV2 = (
    streamId: Uuid,
    params?: GetStreamV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamResponseV2>(
      {url: `/2/streams/${streamId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamV2QueryKey = (streamId: Uuid,
    params?: GetStreamV2Params,) => {
    return [
    `/2/streams/${streamId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamV2QueryOptions = <TData = Awaited<ReturnType<typeof getStreamV2>>, TError = Error | InternalServerErrorResponse>(streamId: Uuid,
    params?: GetStreamV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamV2QueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamV2>>> = ({ signal }) => getStreamV2(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamV2QueryResult = NonNullable<Awaited<ReturnType<typeof getStreamV2>>>
export type GetStreamV2QueryError = Error | InternalServerErrorResponse


export function useGetStreamV2<TData = Awaited<ReturnType<typeof getStreamV2>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params: undefined |  GetStreamV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamV2<TData = Awaited<ReturnType<typeof getStreamV2>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamV2<TData = Awaited<ReturnType<typeof getStreamV2>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream
 */

export function useGetStreamV2<TData = Awaited<ReturnType<typeof getStreamV2>>, TError = Error | InternalServerErrorResponse>(
 streamId: Uuid,
    params?: GetStreamV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamV2QueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update stream fields: *description*, *status*.
 * @summary update stream
 */
export const patchStreamV2 = (
    streamId: Uuid,
    streamToBePatched: StreamToBePatched,
    params?: PatchStreamV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/streams/${streamId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: streamToBePatched,
        params, signal
    },
      options);
    }




export const getPatchStreamV2MutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStreamV2>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchStreamV2>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamV2Params}, TContext> => {

const mutationKey = ['patchStreamV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStreamV2>>, {streamId: Uuid;data: StreamToBePatched;params?: PatchStreamV2Params}> = (props) => {
          const {streamId,data,params} = props ?? {};

          return  patchStreamV2(streamId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchStreamV2MutationResult = NonNullable<Awaited<ReturnType<typeof patchStreamV2>>>
    export type PatchStreamV2MutationBody = StreamToBePatched
    export type PatchStreamV2MutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary update stream
 */
export const usePatchStreamV2 = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStreamV2>>, TError,{streamId: Uuid;data: StreamToBePatched;params?: PatchStreamV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStreamV2>>,
        TError,
        {streamId: Uuid;data: StreamToBePatched;params?: PatchStreamV2Params},
        TContext
      > => {
      return useMutation(getPatchStreamV2MutationOptions(options), queryClient);
    }

/**
 * Remove the stream by ID.
 * @summary remove stream
 */
export const removeStreamV2 = (
    streamId: Uuid,
    params?: RemoveStreamV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/streams/${streamId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getRemoveStreamV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStreamV2>>, TError,{streamId: Uuid;params?: RemoveStreamV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeStreamV2>>, TError,{streamId: Uuid;params?: RemoveStreamV2Params}, TContext> => {

const mutationKey = ['removeStreamV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeStreamV2>>, {streamId: Uuid;params?: RemoveStreamV2Params}> = (props) => {
          const {streamId,params} = props ?? {};

          return  removeStreamV2(streamId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveStreamV2MutationResult = NonNullable<Awaited<ReturnType<typeof removeStreamV2>>>

    export type RemoveStreamV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary remove stream
 */
export const useRemoveStreamV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStreamV2>>, TError,{streamId: Uuid;params?: RemoveStreamV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeStreamV2>>,
        TError,
        {streamId: Uuid;params?: RemoveStreamV2Params},
        TContext
      > => {
      return useMutation(getRemoveStreamV2MutationOptions(options), queryClient);
    }

/**
 * See the streams in the queue.
 * @summary check the streams processing queue
 */
export const getStreamsQueueV2 = (
    params: GetStreamsQueueV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<QueueStreamsResponsePendingV2>(
      {url: `/2/streams/processing/queue`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsQueueV2QueryKey = (params?: GetStreamsQueueV2Params,) => {
    return [
    `/2/streams/processing/queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsQueueV2QueryOptions = <TData = Awaited<ReturnType<typeof getStreamsQueueV2>>, TError = Error | InternalServerErrorResponse>(params: GetStreamsQueueV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsQueueV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsQueueV2>>> = ({ signal }) => getStreamsQueueV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsQueueV2QueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsQueueV2>>>
export type GetStreamsQueueV2QueryError = Error | InternalServerErrorResponse


export function useGetStreamsQueueV2<TData = Awaited<ReturnType<typeof getStreamsQueueV2>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsQueueV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsQueueV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsQueueV2<TData = Awaited<ReturnType<typeof getStreamsQueueV2>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsQueueV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsQueueV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsQueueV2<TData = Awaited<ReturnType<typeof getStreamsQueueV2>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary check the streams processing queue
 */

export function useGetStreamsQueueV2<TData = Awaited<ReturnType<typeof getStreamsQueueV2>>, TError = Error | InternalServerErrorResponse>(
 params: GetStreamsQueueV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsQueueV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsQueueV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 *
 * Receive streams from the queue. The streams are received according to the specified filters.
 *
 * The following actions are performed upon the request:
 *
 * - The streams are marked as "in progress".
 * - The streams are deleted from the Streams Processing Queue.
 *
 * The information about the streams is returned in the response.
 * @summary get some streams from the queue
 */
export const getStreamsFromQueueV2 = (
    postStreamsProcessingQueueRequest?: PostStreamsProcessingQueueRequest,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<QueueStreamsResponseInProgressV2>(
      {url: `/2/streams/processing/queue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postStreamsProcessingQueueRequest, signal
    },
      options);
    }




export const getGetStreamsFromQueueV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueueV2>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueueV2>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext> => {

const mutationKey = ['getStreamsFromQueueV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsFromQueueV2>>, {data?: PostStreamsProcessingQueueRequest}> = (props) => {
          const {data} = props ?? {};

          return  getStreamsFromQueueV2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsFromQueueV2MutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsFromQueueV2>>>
    export type GetStreamsFromQueueV2MutationBody = PostStreamsProcessingQueueRequest | undefined
    export type GetStreamsFromQueueV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary get some streams from the queue
 */
export const useGetStreamsFromQueueV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFromQueueV2>>, TError,{data?: PostStreamsProcessingQueueRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsFromQueueV2>>,
        TError,
        {data?: PostStreamsProcessingQueueRequest},
        TContext
      > => {
      return useMutation(getGetStreamsFromQueueV2MutationOptions(options), queryClient);
    }

/**
 *
 * Post information about streams processing.
 * @summary post feedback on streams
 */
export const postStreamsFeedbackV2 = (
    postStreamsProcessingFeedbackRequest?: PostStreamsProcessingFeedbackRequest,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<FeedbackResponse>(
      {url: `/2/streams/processing/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postStreamsProcessingFeedbackRequest, signal
    },
      options);
    }




export const getPostStreamsFeedbackV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedbackV2>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedbackV2>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext> => {

const mutationKey = ['postStreamsFeedbackV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStreamsFeedbackV2>>, {data?: PostStreamsProcessingFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  postStreamsFeedbackV2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostStreamsFeedbackV2MutationResult = NonNullable<Awaited<ReturnType<typeof postStreamsFeedbackV2>>>
    export type PostStreamsFeedbackV2MutationBody = PostStreamsProcessingFeedbackRequest | undefined
    export type PostStreamsFeedbackV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary post feedback on streams
 */
export const usePostStreamsFeedbackV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedbackV2>>, TError,{data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStreamsFeedbackV2>>,
        TError,
        {data?: PostStreamsProcessingFeedbackRequest},
        TContext
      > => {
      return useMutation(getPostStreamsFeedbackV2MutationOptions(options), queryClient);
    }

/**
 *
 * Get stream last frame preview.
 *
 * To add preview for stream, use ["post feedback on streams"](#operation/postStreamsFeedback) request to create last frame preview.
 * @summary get last frame preview
 */
export const previewFrameProxyV2 = (
    streamId: string,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/streams/${streamId}/preview/handler/frame`, method: 'GET', signal
    },
      options);
    }




export const getPreviewFrameProxyV2QueryKey = (streamId: string,) => {
    return [
    `/2/streams/${streamId}/preview/handler/frame`
    ] as const;
    }


export const getPreviewFrameProxyV2QueryOptions = <TData = Awaited<ReturnType<typeof previewFrameProxyV2>>, TError = Error>(streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewFrameProxyV2QueryKey(streamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewFrameProxyV2>>> = ({ signal }) => previewFrameProxyV2(streamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewFrameProxyV2QueryResult = NonNullable<Awaited<ReturnType<typeof previewFrameProxyV2>>>
export type PreviewFrameProxyV2QueryError = Error


export function usePreviewFrameProxyV2<TData = Awaited<ReturnType<typeof previewFrameProxyV2>>, TError = Error>(
 streamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFrameProxyV2>>,
          TError,
          Awaited<ReturnType<typeof previewFrameProxyV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFrameProxyV2<TData = Awaited<ReturnType<typeof previewFrameProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFrameProxyV2>>,
          TError,
          Awaited<ReturnType<typeof previewFrameProxyV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFrameProxyV2<TData = Awaited<ReturnType<typeof previewFrameProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get last frame preview
 */

export function usePreviewFrameProxyV2<TData = Awaited<ReturnType<typeof previewFrameProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFrameProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewFrameProxyV2QueryOptions(streamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 *
 * Get stream live preview.
 *
 * To add preview for stream, use ["post feedback on streams"](#operation/postStreamsFeedback) request to create live preview.
 * @summary get live preview
 */
export const previewLiveProxyV2 = (
    streamId: string,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/streams/${streamId}/preview/handler/live`, method: 'GET', signal
    },
      options);
    }




export const getPreviewLiveProxyV2QueryKey = (streamId: string,) => {
    return [
    `/2/streams/${streamId}/preview/handler/live`
    ] as const;
    }


export const getPreviewLiveProxyV2QueryOptions = <TData = Awaited<ReturnType<typeof previewLiveProxyV2>>, TError = Error>(streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewLiveProxyV2QueryKey(streamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewLiveProxyV2>>> = ({ signal }) => previewLiveProxyV2(streamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewLiveProxyV2QueryResult = NonNullable<Awaited<ReturnType<typeof previewLiveProxyV2>>>
export type PreviewLiveProxyV2QueryError = Error


export function usePreviewLiveProxyV2<TData = Awaited<ReturnType<typeof previewLiveProxyV2>>, TError = Error>(
 streamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLiveProxyV2>>,
          TError,
          Awaited<ReturnType<typeof previewLiveProxyV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLiveProxyV2<TData = Awaited<ReturnType<typeof previewLiveProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLiveProxyV2>>,
          TError,
          Awaited<ReturnType<typeof previewLiveProxyV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLiveProxyV2<TData = Awaited<ReturnType<typeof previewLiveProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get live preview
 */

export function usePreviewLiveProxyV2<TData = Awaited<ReturnType<typeof previewLiveProxyV2>>, TError = Error>(
 streamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLiveProxyV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewLiveProxyV2QueryOptions(streamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get streams logs according to filters. The results are sorted by log creation order, the new streams logs shown first.
 * @summary get streams logs
 */
export const getStreamsLogsV2 = (
    params?: GetStreamsLogsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamsLogs>(
      {url: `/2/streams/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsLogsV2QueryKey = (params?: GetStreamsLogsV2Params,) => {
    return [
    `/2/streams/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsLogsV2QueryOptions = <TData = Awaited<ReturnType<typeof getStreamsLogsV2>>, TError = Error | InternalServerErrorResponse>(params?: GetStreamsLogsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsLogsV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsLogsV2>>> = ({ signal }) => getStreamsLogsV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsLogsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsLogsV2>>>
export type GetStreamsLogsV2QueryError = Error | InternalServerErrorResponse


export function useGetStreamsLogsV2<TData = Awaited<ReturnType<typeof getStreamsLogsV2>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetStreamsLogsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogsV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogsV2<TData = Awaited<ReturnType<typeof getStreamsLogsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogsV2>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogsV2<TData = Awaited<ReturnType<typeof getStreamsLogsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams logs
 */

export function useGetStreamsLogsV2<TData = Awaited<ReturnType<typeof getStreamsLogsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetStreamsLogsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsLogsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams logs older than specified date excluding last log entry.
 * @summary delete stream logs
 */
export const deleteStreamsLogsV2 = (
    params?: DeleteStreamsLogsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<StreamsLogsDeletedCount>(
      {url: `/2/streams/logs`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteStreamsLogsV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogsV2>>, TError,{params?: DeleteStreamsLogsV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogsV2>>, TError,{params?: DeleteStreamsLogsV2Params}, TContext> => {

const mutationKey = ['deleteStreamsLogsV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreamsLogsV2>>, {params?: DeleteStreamsLogsV2Params}> = (props) => {
          const {params} = props ?? {};

          return  deleteStreamsLogsV2(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsLogsV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreamsLogsV2>>>

    export type DeleteStreamsLogsV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary delete stream logs
 */
export const useDeleteStreamsLogsV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogsV2>>, TError,{params?: DeleteStreamsLogsV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreamsLogsV2>>,
        TError,
        {params?: DeleteStreamsLogsV2Params},
        TContext
      > => {
      return useMutation(getDeleteStreamsLogsV2MutationOptions(options), queryClient);
    }

/**
 * Create group.
 * @summary create group
 */
export const createGroupV2 = (
    createGroup: CreateGroup,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<CreateGroupResponse>(
      {url: `/2/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroup, signal
    },
      options);
    }




export const getCreateGroupV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupV2>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroupV2>>, TError,{data: CreateGroup}, TContext> => {

const mutationKey = ['createGroupV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupV2>>, {data: CreateGroup}> = (props) => {
          const {data} = props ?? {};

          return  createGroupV2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupV2MutationResult = NonNullable<Awaited<ReturnType<typeof createGroupV2>>>
    export type CreateGroupV2MutationBody = CreateGroup
    export type CreateGroupV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary create group
 */
export const useCreateGroupV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupV2>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroupV2>>,
        TError,
        {data: CreateGroup},
        TContext
      > => {
      return useMutation(getCreateGroupV2MutationOptions(options), queryClient);
    }

/**
 * Get groups according to filters. The results are sorted by group creation order, the oldest group shown first.
 * @summary get groups
 */
export const getGroupsV2 = (
    params?: GetGroupsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetGroupsV2200>(
      {url: `/2/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupsV2QueryKey = (params?: GetGroupsV2Params,) => {
    return [
    `/2/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupsV2QueryOptions = <TData = Awaited<ReturnType<typeof getGroupsV2>>, TError = Error | InternalServerErrorResponse>(params?: GetGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupsV2>>> = ({ signal }) => getGroupsV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getGroupsV2>>>
export type GetGroupsV2QueryError = Error | InternalServerErrorResponse


export function useGetGroupsV2<TData = Awaited<ReturnType<typeof getGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetGroupsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsV2>>,
          TError,
          Awaited<ReturnType<typeof getGroupsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsV2<TData = Awaited<ReturnType<typeof getGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsV2>>,
          TError,
          Awaited<ReturnType<typeof getGroupsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsV2<TData = Awaited<ReturnType<typeof getGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroupsV2<TData = Awaited<ReturnType<typeof getGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: GetGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Count of groups according to the filters.
 * @summary get group count
 */
export const countGroupsV2 = (
    params?: CountGroupsV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GroupsCount>(
      {url: `/2/groups/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountGroupsV2QueryKey = (params?: CountGroupsV2Params,) => {
    return [
    `/2/groups/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountGroupsV2QueryOptions = <TData = Awaited<ReturnType<typeof countGroupsV2>>, TError = Error | InternalServerErrorResponse>(params?: CountGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountGroupsV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countGroupsV2>>> = ({ signal }) => countGroupsV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountGroupsV2QueryResult = NonNullable<Awaited<ReturnType<typeof countGroupsV2>>>
export type CountGroupsV2QueryError = Error | InternalServerErrorResponse


export function useCountGroupsV2<TData = Awaited<ReturnType<typeof countGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  CountGroupsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroupsV2>>,
          TError,
          Awaited<ReturnType<typeof countGroupsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroupsV2<TData = Awaited<ReturnType<typeof countGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroupsV2>>,
          TError,
          Awaited<ReturnType<typeof countGroupsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroupsV2<TData = Awaited<ReturnType<typeof countGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group count
 */

export function useCountGroupsV2<TData = Awaited<ReturnType<typeof countGroupsV2>>, TError = Error | InternalServerErrorResponse>(
 params?: CountGroupsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroupsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountGroupsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get the group by name.
 * @summary get group
 */
export const getGroupV2 = (
    groupId: Uuid,
    params?: GetGroupV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GroupResponse>(
      {url: `/2/groups/${groupId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupV2QueryKey = (groupId: Uuid,
    params?: GetGroupV2Params,) => {
    return [
    `/2/groups/${groupId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupV2QueryOptions = <TData = Awaited<ReturnType<typeof getGroupV2>>, TError = Error | InternalServerErrorResponse>(groupId: Uuid,
    params?: GetGroupV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupV2QueryKey(groupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupV2>>> = ({ signal }) => getGroupV2(groupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupV2QueryResult = NonNullable<Awaited<ReturnType<typeof getGroupV2>>>
export type GetGroupV2QueryError = Error | InternalServerErrorResponse


export function useGetGroupV2<TData = Awaited<ReturnType<typeof getGroupV2>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params: undefined |  GetGroupV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupV2>>,
          TError,
          Awaited<ReturnType<typeof getGroupV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupV2<TData = Awaited<ReturnType<typeof getGroupV2>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupV2>>,
          TError,
          Awaited<ReturnType<typeof getGroupV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupV2<TData = Awaited<ReturnType<typeof getGroupV2>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group
 */

export function useGetGroupV2<TData = Awaited<ReturnType<typeof getGroupV2>>, TError = Error | InternalServerErrorResponse>(
 groupId: Uuid,
    params?: GetGroupV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupV2QueryOptions(groupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update group fields: *description*
 * @summary update group
 */
export const patchGroupV2 = (
    groupId: Uuid,
    updateGroup: UpdateGroup,
    params?: PatchGroupV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroup,
        params, signal
    },
      options);
    }




export const getPatchGroupV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupV2>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchGroupV2>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupV2Params}, TContext> => {

const mutationKey = ['patchGroupV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGroupV2>>, {groupId: Uuid;data: UpdateGroup;params?: PatchGroupV2Params}> = (props) => {
          const {groupId,data,params} = props ?? {};

          return  patchGroupV2(groupId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchGroupV2MutationResult = NonNullable<Awaited<ReturnType<typeof patchGroupV2>>>
    export type PatchGroupV2MutationBody = UpdateGroup
    export type PatchGroupV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary update group
 */
export const usePatchGroupV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupV2>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGroupV2>>,
        TError,
        {groupId: Uuid;data: UpdateGroup;params?: PatchGroupV2Params},
        TContext
      > => {
      return useMutation(getPatchGroupV2MutationOptions(options), queryClient);
    }

/**
 * Remove the group by name.
 * @summary remove group
 */
export const deleteGroupV2 = (
    groupId: Uuid,
    params?: DeleteGroupV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/groups/${groupId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteGroupV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroupV2>>, TError,{groupId: Uuid;params?: DeleteGroupV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroupV2>>, TError,{groupId: Uuid;params?: DeleteGroupV2Params}, TContext> => {

const mutationKey = ['deleteGroupV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroupV2>>, {groupId: Uuid;params?: DeleteGroupV2Params}> = (props) => {
          const {groupId,params} = props ?? {};

          return  deleteGroupV2(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroupV2>>>

    export type DeleteGroupV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary remove group
 */
export const useDeleteGroupV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroupV2>>, TError,{groupId: Uuid;params?: DeleteGroupV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroupV2>>,
        TError,
        {groupId: Uuid;params?: DeleteGroupV2Params},
        TContext
      > => {
      return useMutation(getDeleteGroupV2MutationOptions(options), queryClient);
    }

/**
 * Attach (or detach) streams to a group.
 * @summary attach (or detach) streams to a group
 */
export const linkerV2 = (
    linker?: Linker,
    params?: LinkerV2Params,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<void>(
      {url: `/2/linker`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: linker,
        params, signal
    },
      options);
    }




export const getLinkerV2MutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkerV2>>, TError,{data?: Linker;params?: LinkerV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof linkerV2>>, TError,{data?: Linker;params?: LinkerV2Params}, TContext> => {

const mutationKey = ['linkerV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkerV2>>, {data?: Linker;params?: LinkerV2Params}> = (props) => {
          const {data,params} = props ?? {};

          return  linkerV2(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkerV2MutationResult = NonNullable<Awaited<ReturnType<typeof linkerV2>>>
    export type LinkerV2MutationBody = Linker | undefined
    export type LinkerV2MutationError = Error | InternalServerErrorResponse

    /**
 * @summary attach (or detach) streams to a group
 */
export const useLinkerV2 = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkerV2>>, TError,{data?: Linker;params?: LinkerV2Params}, TContext>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkerV2>>,
        TError,
        {data?: Linker;params?: LinkerV2Params},
        TContext
      > => {
      return useMutation(getLinkerV2MutationOptions(options), queryClient);
    }

/**
 * Get service OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept-Type* is `text/html`
 * @summary get openapi documentation
 */
export const getSpecV2 = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<string>(
      {url: `/2/docs/spec`, method: 'GET', signal
    },
      options);
    }




export const getGetSpecV2QueryKey = () => {
    return [
    `/2/docs/spec`
    ] as const;
    }


export const getGetSpecV2QueryOptions = <TData = Awaited<ReturnType<typeof getSpecV2>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecV2QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpecV2>>> = ({ signal }) => getSpecV2(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpecV2QueryResult = NonNullable<Awaited<ReturnType<typeof getSpecV2>>>
export type GetSpecV2QueryError = Error | InternalServerErrorResponse


export function useGetSpecV2<TData = Awaited<ReturnType<typeof getSpecV2>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpecV2>>,
          TError,
          Awaited<ReturnType<typeof getSpecV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpecV2<TData = Awaited<ReturnType<typeof getSpecV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpecV2>>,
          TError,
          Awaited<ReturnType<typeof getSpecV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpecV2<TData = Awaited<ReturnType<typeof getSpecV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get openapi documentation
 */

export function useGetSpecV2<TData = Awaited<ReturnType<typeof getSpecV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpecV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpecV2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get sphinx documentation - *Development Manual*. After the request you will be redirected to the page `/docs/dev/index.html`
 * @summary get development manual
 */
export const getDevManualV2 = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<string>(
      {url: `/2/docs/dev`, method: 'GET', signal
    },
      options);
    }




export const getGetDevManualV2QueryKey = () => {
    return [
    `/2/docs/dev`
    ] as const;
    }


export const getGetDevManualV2QueryOptions = <TData = Awaited<ReturnType<typeof getDevManualV2>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevManualV2QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevManualV2>>> = ({ signal }) => getDevManualV2(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevManualV2QueryResult = NonNullable<Awaited<ReturnType<typeof getDevManualV2>>>
export type GetDevManualV2QueryError = InternalServerErrorResponse


export function useGetDevManualV2<TData = Awaited<ReturnType<typeof getDevManualV2>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManualV2>>,
          TError,
          Awaited<ReturnType<typeof getDevManualV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManualV2<TData = Awaited<ReturnType<typeof getDevManualV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManualV2>>,
          TError,
          Awaited<ReturnType<typeof getDevManualV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManualV2<TData = Awaited<ReturnType<typeof getDevManualV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get development manual
 */

export function useGetDevManualV2<TData = Awaited<ReturnType<typeof getDevManualV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManualV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevManualV2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get service configuration. Passwords and tokens will be hidden in the response.
 * @summary get service configuration
 */
export const getConfigV2 = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<GetConfigV2200One | string>(
      {url: `/2/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigV2QueryKey = () => {
    return [
    `/2/config`
    ] as const;
    }


export const getGetConfigV2QueryOptions = <TData = Awaited<ReturnType<typeof getConfigV2>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigV2QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigV2>>> = ({ signal }) => getConfigV2(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigV2QueryResult = NonNullable<Awaited<ReturnType<typeof getConfigV2>>>
export type GetConfigV2QueryError = Error | InternalServerErrorResponse


export function useGetConfigV2<TData = Awaited<ReturnType<typeof getConfigV2>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigV2>>,
          TError,
          Awaited<ReturnType<typeof getConfigV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigV2<TData = Awaited<ReturnType<typeof getConfigV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigV2>>,
          TError,
          Awaited<ReturnType<typeof getConfigV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigV2<TData = Awaited<ReturnType<typeof getConfigV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service configuration
 */

export function useGetConfigV2<TData = Awaited<ReturnType<typeof getConfigV2>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigV2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get list of service plugins
 * @summary get list of plugins
 */
export const getPluginsV2 = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<Plugins>(
      {url: `/2/plugins`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsV2QueryKey = () => {
    return [
    `/2/plugins`
    ] as const;
    }


export const getGetPluginsV2QueryOptions = <TData = Awaited<ReturnType<typeof getPluginsV2>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsV2QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginsV2>>> = ({ signal }) => getPluginsV2(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPluginsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getPluginsV2>>>
export type GetPluginsV2QueryError = InternalServerErrorResponse


export function useGetPluginsV2<TData = Awaited<ReturnType<typeof getPluginsV2>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPluginsV2>>,
          TError,
          Awaited<ReturnType<typeof getPluginsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPluginsV2<TData = Awaited<ReturnType<typeof getPluginsV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPluginsV2>>,
          TError,
          Awaited<ReturnType<typeof getPluginsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPluginsV2<TData = Awaited<ReturnType<typeof getPluginsV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of plugins
 */

export function useGetPluginsV2<TData = Awaited<ReturnType<typeof getPluginsV2>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPluginsV2>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPluginsV2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get statistics of success and failed requests to the service in prometheus format.
 * @summary get service requests statistics
 */
export const metrics = (

 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<string>(
      {url: `/metrics`, method: 'GET', signal
    },
      options);
    }




export const getMetricsQueryKey = () => {
    return [
    `/metrics`
    ] as const;
    }


export const getMetricsQueryOptions = <TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({ signal }) => metrics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricsQueryResult = NonNullable<Awaited<ReturnType<typeof metrics>>>
export type MetricsQueryError = ForbiddenResourceErrorResponse | InternalServerErrorResponse


export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service requests statistics
 */

export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get health of service.
 * @summary get health
 */
export const healthcheck = (
    params?: HealthcheckParams,
 options?: SecondParameter<typeof streamsAxiosClient>,signal?: AbortSignal
) => {


      return streamsAxiosClient<HealthOk>(
      {url: `/healthcheck`, method: 'GET',
        params, signal
    },
      options);
    }




export const getHealthcheckQueryKey = (params?: HealthcheckParams,) => {
    return [
    `/healthcheck`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheck>>> = ({ signal }) => healthcheck(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheck>>>
export type HealthcheckQueryError = InternalServerErrorResponse | HealthErrors


export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params: undefined |  HealthcheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get health
 */

export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof streamsAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







